<template>
<div>

  <v-card>
    <v-card-title>
      {{titulo}}
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="fas fa-search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <template>
      <v-row>
        <v-col>
          <v-sheet>
            <v-calendar
              v-model="today"
              :now="today"
              :max="new Date()"
              type="week"
              color="primary"
              :weekdays="[0, 1, 2, 3, 4, 5, 6]"
              :interval-count="0"
              @click:date="getBanks"
            ></v-calendar>
          </v-sheet>
        </v-col>
      </v-row>
    </template>
    <v-alert
      v-if="showAlert"
      dense
      shaped
      border="left"
      type="warning"
      max-width="600"
      class="mx-auto text-center mt-2 mb-2">
      La fecha seleccionada no corresponde al día de hoy. Verifica tu selección.
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="banks"
      :search="search"
      sort-by="name"
      class="elevation-1"
      :loading="loading"
      loading-text="Consultando datos... Espere por favor"
    >

      <template v-slot:[`item.part_time`]="{ item }">
        <v-switch
          v-model="item.part_time"
          inset
          class="ml-2"
          color="warning"
          @change="handleSwitchChange(item, 'part_time')"
        ></v-switch>
      </template>

      <template v-slot:[`item.fulltime`]="{ item }">
        <v-switch
          v-model="item.fulltime"
          inset
          class="ml-4"
          @change="handleSwitchChange(item, 'fulltime')"
        ></v-switch>
      </template>

    </v-data-table>
  </v-card>
</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import * as moment from 'moment';

export default {
  name: "attendance",
  data: () => ({
    dialog: false,
    showAlert: false,
    banks: [],
    dialogDelete: false,
    search: "",
    menu: false,
    loading: false,
    today: new Date().toLocaleDateString("en-CA"),
    titulo: "Registro de Asistencia",
    headers: [
    { text: "IDENTIDAD", align: "left", value: "rtn" },
      { text: "NOMBRE", align: "left", value: "name" },
      { text: "MEDIO DÍA", align: "left", value: "part_time" },
      { text: "DÍA COMPLETO", align: "left", value: "fulltime" },
    ],
    editedIndex: -1,

    valid: true,
    editedItem: {
      id: "",
      part_time: "",
      fulltime: ""
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Registro" : "Editar Registro";
    },
    ...mapState(["db","headers_db"]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    ...mapActions(["cerrarSesion", "validateSession"]),
    // Metodos base de datos

    async getBanks(day){
      this.loading = true;
      let date = day && day.date ? day.date : this.today;
      this.today = date;
      
      if (date != new Date().toLocaleDateString("en-CA")) {
        this.showAlert = true;
      }
      else this.showAlert = false;

      await axios.get(this.db + 'payroll/attendance/'+ this.today,
        {
          headers: this.headers_db
        }).then(response => {
          this.banks = response.data.data;
          this.banks.forEach(item => {
            item.part_time = (item.part_time == 1) ? true : false;
            item.fulltime = (item.fulltime == 1) ? true : false;
          });
          this.loading = false;
          console.log(response.data.data);
        })
        .catch((error) => {
          this.validateSession(error).then((resp) => { if(resp) this.getBanks(); })
        });
    },

    updateProcess(payload){
      payload.fulltime = payload.fulltime ? 1 : 0,
      payload.part_time = payload.part_time ? 1 : 0,
      payload.date = this.today;
      console.log(payload);
      axios.post(this.db + 'payroll/attendance/update', payload,
      {
        headers: this.headers_db
      })
      .then((response) => {
        console.log(response);
        this.$store.dispatch("setSnackbar", {
          text: response.data.message,
        });
        this.getBanks();
      })
      .catch((error) => {
        this.validateSession(error).then((resp) => { if(resp) this.updateProcess(payload); })
      });

    },
    // FIN Metodos base de datos


    // Metodos Generales
    dateFormat(date) {
      return moment(date).format('DD/MM/YYYY');
    },

    selectOption() {
      if (!this.place) {
        this.$refs.form2.validate();
      }
    },

    editItem(item) {
      console.log(item);

      this.editedIndex = this.banks.indexOf(item);
      this.dialog = true;
      this.editedItem = Object.assign({}, item);
    },

    deleteItem(item) {
      console.log(item.id);

      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    close() {
      this.dialog = false;
      this.dialogDelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.currencyMask = "";
        this.editedIndex = -1;
      }, 300);
    },

    handleSwitchChange(item, switchType) {
      // Si se marca 'part_time', desmarcar 'fulltime'
      if (switchType === 'part_time' && item.part_time) {
        item.fulltime = false;
      }
      
      if (switchType === 'fulltime' && item.fulltime) {
        item.part_time = false;
      }
      
      this.updateProcess(item); 
    },

    eliminar() {
      this.deleteProcess(this.editedItem.id);
      this.close();
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

  },

  mounted() {
    console.log(this.today);
    
    this.getBanks();
  },
};
</script>